export default __webpack_public_path__ + "static/media/logo-chequer.38300d2c.png";